import React, { useMemo, useState, useCallback, memo } from 'react';
import cloneDeep from 'lodash/cloneDeep';

import { GenericDiv, GenericP } from 'common/Styles';
import Button from 'common/Button/Button';
import Modal from 'common/Modal/Modal';
import DropQueryForm from './DropQueryForm';
import { queryFormFields, QUERY_MODAL } from '../../config';
import { PATHS, APPLICATION_CONSTANTS, MICE_CONSTANTS } from 'AppConstants';
import { ASSET_PATH } from 'assetsPath';
import Timer from 'UtilityComponents/Timer';
import { queryFormApi } from '../../../../apis';
import { formatQueryForm, trackClick } from 'UtilityComponents/venueUtils';

const timeOut = 10;
let startTimer = false;

const RequestDemo = ({ closeForm, isMobile }) => {
	const [status, setStatus] = useState(false);
	const [errorMsg, setErrorMsg] = useState(false);
	const succMsg = QUERY_MODAL.SUCCESS_HEADING;

	const closeRequestDemo = useCallback(() => {
		clearTimeout(startTimer);
		closeForm();
	}, [closeForm]);

	const Modaldata = useMemo(() => ({
		title: status === APPLICATION_CONSTANTS.SUCCESS ? succMsg : QUERY_MODAL.HEADING,
		mobileTitle: status === APPLICATION_CONSTANTS.SUCCESS ? succMsg : QUERY_MODAL.HEADING,
		subTitle: status === APPLICATION_CONSTANTS.SUCCESS ?
			'' : QUERY_MODAL.SUBHEADING,
		img: status === APPLICATION_CONSTANTS.SUCCESS ? (ASSET_PATH.IMAGES + 'Tick.png') : null,
		imgstyle: 'tick-succ',
		customClass: status === APPLICATION_CONSTANTS.SUCCESS ? 'request-demo-succ' : '',
		btnTxt: null
	}), [status, succMsg]);

	const formFields = useMemo(()=> cloneDeep(queryFormFields), []);

	const handleSubmit = useCallback(async (e) => {
		e.preventDefault();
		let error = false;
		trackClick('query_submitted');
		try {
			const formData = formatQueryForm(formFields);
			setStatus(APPLICATION_CONSTANTS.PENDING);
			const response = await queryFormApi(formData);
			const responseData = response && response.data;
			if (responseData && responseData.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE) {
				setStatus(APPLICATION_CONSTANTS.SUCCESS);
				setErrorMsg('');
				startTimer = setTimeout(() => {
					window.location = PATHS.MYBIZ_URL;
				}, timeOut * 1000);
				return;
			}
			error = true;
			setErrorMsg(responseData.message);
		} catch (e) {
			error = true;
			setErrorMsg(APPLICATION_CONSTANTS.GENERIC_API_ERROR);
		} finally {
			if (error) {
				setStatus(false);
			}
		}
	}, [formFields]);

	return (
		<Modal
			close
			Modaldata={Modaldata}
			width='510px'
			style={{ height: '570px' }}
			handleModal={closeRequestDemo}
			isResponsive
			isMobile={isMobile}
			errorMsg={errorMsg}>
			{status === APPLICATION_CONSTANTS.SUCCESS ?
				<GenericDiv left_P={isMobile ? '15' : 0} right_P={isMobile ? '15' : 0}>

					<GenericP bottom_M='20' text_align='center'>
						{MICE_CONSTANTS.SUCCESS_DESC1}
					</GenericP>
					<GenericP bottom_M='30' text_align='center'>
						{MICE_CONSTANTS.SUCCESS_DES2}
					</GenericP>
					<Button
						btnTxt='OK'
						btnType='Flat'
						btnName='Primary'
						btnShadow
						btnWidth='100%'
						height='44px'
						handleClick={closeRequestDemo}
					/>
					<GenericP top_M='25' text_align='center'>
						{APPLICATION_CONSTANTS.AUTO_REDIRECT}  <Timer startTime={timeOut} />.
					</GenericP>
				</GenericDiv> :
				<div style={isMobile ? { 'overflow': 'auto' } : { 'overflow': 'visible' }}>
					<DropQueryForm status={status} handleSubmit={handleSubmit} formFields={formFields} />
				</div>}
		</Modal>
	);
};

export default memo(RequestDemo);
